import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import jwt from 'jsonwebtoken'
import router from '@/router'

var baseURL = "https://gem.vdot.cloud/api"
  var axios = Axios.create({
    //   baseURL: process.env.VUE_APP_API_URL
    baseURL: baseURL
  })

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authStatus: '',
    sendStatus:'',
    token: localStorage.getItem('token') || '',
    isMobile: false,
    deviceSize: 0,
  },
  getters: {
    authorized: state => !!state.token,
    authstatus: state => state.authStatus,
    isMobile: state => state.deviceSize < 768
  },
  mutations: {
    auth_request (state) {
     state.authStatus = 'loading'
    },
    sending (state) {
        state.sendStatus = 'sending'
       },
    getting (state) {
        state.sendStatus = 'getting'
     },
    auth_success (state, { token}) {
      state.authStatus = 'success'
      state.token = token
    },
    auth_error (state) {
      state.authStatus = 'error'
    },
    resize (state, deviceSize){
      state.deviceSize = deviceSize;
    },
    logout (state) {
      state.authStatus = ''
      state.token = ''
    }
  },
  actions: {
    login ({ commit }, userData) {
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios.post('login', { username: userData.username, password: userData.password })
            .then(response => {
              const token = response.data.access_token
              const refreshToken = response.data.refresh_token;
              const decoded = jwt.decode(token);
              const name = decoded.name
              const permission = decoded.permissions
              localStorage.setItem('permission', permission)
              // storing jwt in localStorage. https cookie is safer place to store
              localStorage.setItem('name', name)
              localStorage.setItem('token', token)
              localStorage.setItem('refreshToken', refreshToken)
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              // mutation to change state properties to the values passed along
              commit('auth_success', {token})
              resolve(response)
            })
            .catch(err => {
              console.log(err)

              commit('auth_error')
              localStorage.removeItem('token')
              reject(err)
            })
        })
  },
  initCheckConnection(){
    return new Promise((resolve, reject) => {
      axios.get('/scan/connections',  {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {

          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  initScan(){
    return new Promise((resolve, reject) => {
      axios.get('/scan/init',  {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {

          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  saveSheet({ commit }, userData  ){
    return new Promise((resolve, reject) => {
      axios.post('/sheets/save/' + userData.sheetName, {sheet: userData.sheet} , {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {

          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  build({ commit }, userData  ){
    return new Promise((resolve, reject) => {
      axios.post('/sheets/build/' + userData.sheetName ,{empty: "empty"}, {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {

          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  getSheetData ({ commit }, userData  ) {
    commit('getting')
    return new Promise((resolve, reject) => {
      axios.get('/sheets/'+ userData.sheetName,  {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },

getDomainList () {
  return new Promise((resolve, reject) => {
    axios.get('/domains/list',  {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {

        resolve(response)
      })
      .catch(err => {
        console.log(err)
        reject(err)
      })
  })
},
  logout ({ commit }) {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('name')
      localStorage.removeItem('refreshToken')
      delete axios.defaults.headers.common['Authorization']
      router.push('/')
      resolve()
    })
  },
  refreshToken ({ commit }) {
    return axios.get('refresh_token', {headers: {'Authorization': "bearer " + localStorage.getItem('refreshToken')}})
      .then(response => {
        const token = response.data.access_token
        const decoded = jwt.decode(token);
        const name = decoded.name
        const permission = decoded.permissions
        localStorage.setItem('permission', permission)
        if(permission == "finance"){
          this.state.isFinance = true
        }
        localStorage.setItem('token', token)
        localStorage.setItem('name', name)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      })
      .catch(() => {
        commit('logout')
        localStorage.removeItem('token')
        router.push('/');
      })
  },


  }
})
